import { CALLBACK_PATH } from "../routes.ts";

/** A page bundle under `/static/build/`. */
export type Entry = "main" | "bigscreen" | "callback";

/**
 * The stage and its control view lived here before Big Screen
 * (`apps/bigscreen`) took them; TVs and the AV runbook still have these URLs
 * bookmarked, so they load a redirect to the new host (`bigscreen.ts`).
 */
const OLD_STAGE_PAGES = new URLPattern({
  pathname: "/workspaces/:workspaceId/:page(stage|stage-control)",
});

/** The bundle for a pathname: the Big Screen redirect, sign-in's callback, else the desktop app. */
export const entryOf = (pathname: string): Entry =>
  pathname === CALLBACK_PATH
    ? "callback"
    : OLD_STAGE_PAGES.test({ pathname })
      ? "bigscreen"
      : "main";
